function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#right-chevron-orange_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.172 61.81a4.112 4.112 0 01-.333-5.364l.333-.383 21.164-21.507L9.172 13.048a4.112 4.112 0 01-.333-5.364l.333-.383a3.955 3.955 0 015.28-.338l.376.338 24 24.381a4.112 4.112 0 01.333 5.364l-.333.383-24 24.38a3.956 3.956 0 01-5.656 0z",
  fill: "#EA7927"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "right-chevron-orange_svg__filter0_d",
  x: 0,
  y: 0.111,
  width: 48,
  height: 72.889,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgRightChevronOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 73"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA3MyI+PGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPjxwYXRoIGQ9Ik05LjE3MiA2MS44MWE0LjExMiA0LjExMiAwIDAxLS4zMzMtNS4zNjRsLjMzMy0uMzgzIDIxLjE2NC0yMS41MDdMOS4xNzIgMTMuMDQ4YTQuMTEyIDQuMTEyIDAgMDEtLjMzMy01LjM2NGwuMzMzLS4zODNhMy45NTUgMy45NTUgMCAwMTUuMjgtLjMzOGwuMzc2LjMzOCAyNCAyNC4zODFhNC4xMTIgNC4xMTIgMCAwMS4zMzMgNS4zNjRsLS4zMzMuMzgzLTI0IDI0LjM4YTMuOTU2IDMuOTU2IDAgMDEtNS42NTYgMHoiIGZpbGw9IiNFQTc5MjciLz48L2c+PGRlZnM+PGZpbHRlciBpZD0iZmlsdGVyMF9kIiB4PSIwIiB5PSIuMTExIiB3aWR0aD0iNDgiIGhlaWdodD0iNzIuODg5IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+PGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiLz48ZmVPZmZzZXQgZHk9IjIiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI0Ii8+PGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjE2IDAiLz48ZmVCbGVuZCBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz48ZmVCbGVuZCBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz48L2ZpbHRlcj48L2RlZnM+PC9zdmc+";
export { SvgRightChevronOrange as ReactComponent };